import _ from 'lodash';
// import Big from 'big.js';

export const compareStowedDiscounts = ({ bogoCalcsData, detail, stowedDiscounts, globalSpecialsSettings }) => {
  const discountsChosen = {};
  const { nonStackingBehavior } = globalSpecialsSettings;
  const saleAdjustments = {};
  const stackingDiscounts = {};
  let lostBogoDiscountCount = 0;
  let discountToCartDefeated = false;

  // Returns true if the challenging discount wins, but false if the champion discount holds its title
  const compareDiscounts = (champion, challenger) =>
    !!(
      !champion ||
      ((nonStackingBehavior === 'favorCustomer' || challenger?.discountData?.discountMode === 'non-stacking') &&
        challenger.individualDiscount.gt(champion.individualDiscount)) ||
      (nonStackingBehavior === 'favorDispensary' && challenger.individualDiscount.lt(champion.individualDiscount))
    );

  _.times(detail.quantity, () => {
    let bogoDefeated = false;
    let losingDiscount;
    let saleRunnerUp;
    let winningDiscount;

    _.forEachRight(stowedDiscounts, (discount) => {
      // If an individually stacking special, add to stackingDiscounts
      if (discount.discountData?.stackingMode === 'stacking' || discount.discountData.discountStacking === true) {
        stackingDiscounts[discount.key] = {
          ...discount,
          count: (stackingDiscounts[discount.key]?.count || 0) + 1,
        };
      } else {
        // Otherwise compare the discount with others
        if ((discountsChosen[discount.key]?.count || 0) < discount.applicableQuantity) {
          if (compareDiscounts(winningDiscount, discount)) {
            if (winningDiscount) {
              losingDiscount = winningDiscount;
            }
            winningDiscount = discount;
          } else {
            losingDiscount = discount;
          }
        }

        if (losingDiscount?.type === 'bogo') {
          if (!losingDiscount.discountData?.isDiscountToCartReward) {
            bogoDefeated = true;
          } else {
            /*
              We dont' want to add this product to the defeatedRewardSatisfiers like
              when a normal bogo is defeated because then the reward that beat this
              discount to cart reward will be eligible to apply again in the call to
              redetermine bogo discounts. We will instead track this defeated DTC offer
              in it's own structure on the bogoCalcsData: defeatedDiscountToCartRewards
             */
            discountToCartDefeated = true;
            /*
              this structure will be used when the rewards are redetermined to remove this
              product from the list that we spread the discount across
            */
            _.set(
              bogoCalcsData,
              `defeatedDiscountToCartRewards.${losingDiscount.discountData.rewardId}.${detail.key}`,
              {
                item: detail,
              }
            );
          }
        } else if (losingDiscount?.type === 'sale') {
          saleRunnerUp = compareDiscounts(saleRunnerUp, discount) ? discount : saleRunnerUp;
        }
      }
    });

    if (bogoDefeated) {
      lostBogoDiscountCount += 1;
    }
    // We need to adjust cart, cart total, and summary items at checkout if sales are defeated by bogos or coupons
    if (saleRunnerUp && (winningDiscount?.type === 'bogo' || winningDiscount?.type === 'coupon')) {
      saleAdjustments[saleRunnerUp.key] = {
        discount: saleRunnerUp,
        count: (saleAdjustments[saleRunnerUp.key]?.count || 0) + 1,
      };
    }

    if (winningDiscount) {
      discountsChosen[winningDiscount.key] = {
        ...winningDiscount,
        count: (discountsChosen[winningDiscount.key]?.count || 0) + 1,
      };
    }
  });

  if (lostBogoDiscountCount > 0) {
    _.set(bogoCalcsData, `defeatedRewardsSatisfiers.${detail.key}`, {
      item: detail,
      quantity: lostBogoDiscountCount,
      discountToCartDefeated,
    });
    bogoCalcsData.redetermineDiscounts = true;
  }
  if (discountToCartDefeated) {
    bogoCalcsData.redetermineDiscounts = true;
  }
  if (!_.isEmpty(saleAdjustments)) {
    detail.saleAdjustments = saleAdjustments;
  }

  return {
    bogoCalcsData,
    detail,
    stowedDiscounts: _.reduce(
      stowedDiscounts,
      (winningDiscounts, discount) => {
        const discountCount = stackingDiscounts[discount.key]?.count || discountsChosen[discount.key]?.count || 0;

        if (discountCount > 0) {
          winningDiscounts.push({
            ...discount,
            quantityToApply: discountCount,
            type: discount.type,
          });
        }

        return winningDiscounts;
      },
      []
    ),
  };
};
